import { render, staticRenderFns } from "./EditCompanyProgramColor.vue?vue&type=template&id=f8a5a500"
import script from "./EditCompanyProgramColor.vue?vue&type=script&lang=js"
export * from "./EditCompanyProgramColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports